<app-topbar></app-topbar>
<main class="layout-container">
  <div class="layout-content-wrapper">
    <div class="layout-content">
      <div class="grid justify-content-center">
        <div class="col-12 md:col-10 form-container">
          <form [formGroup]="cadastro">
            <p-card class="card custom-card">
              <ng-template pTemplate="header">
                <div class="card-header">
                  <h3 class="card-title">Cadastre seu prompt</h3>
                </div>
              </ng-template>

              <div class="mx-2 field">
                <label for="titulo" class="font-normal">Título
                  <span class="text-red-500">*</span>
                </label>
                <input placeholder="Título" class="mt-1" pInputText required="true" formControlName="titulo" />
              </div>

              <div class="mx-2 mt-3 field">
                <label for="resumo" class="font-normal">Resumo
                  <span class="text-red-500">*</span>
                </label>
                <textarea class="mt-1" pInputTextarea required="true" rows="5" placeholder="Descrição"
                  [autoResize]="true" minlength="0" [maxlength]="MAX_RESUMO" formControlName="resumo"></textarea>
                <span class="text-500">
                  {{ qtdCaracteres("resumo") }} / {{ MAX_RESUMO }}
                </span>
              </div>
              <div class="mx-2 mt-3 field">
                <label for="prompt" class="font-normal">
                  Prompt
                  <span class="text-red-500">*</span>
                </label>
                <textarea class="mt-1" pInputTextarea required="true" rows="10" placeholder="Descreva seu prompt"
                  [autoResize]="true" minlength="0" [maxlength]="MAX_PROMPT" formControlName="prompt"></textarea>
                <span class="text-500">
                  {{ qtdCaracteres("prompt") }} / {{ MAX_PROMPT }}
                </span>
              </div>

             <div class="mx-2 mt-3 field">
  <label for="tags" class="font-normal text-600">Palavras-chave (opcional)</label>
  <div class="tags-container">
    <div class="tag" *ngFor="let tag of tags">
      {{ tag }}
      <span class="remove-tag" (click)="removeTag(tag)">×</span>
    </div>
    <input type="text"
      title="Separe as tags com vírgula. Ao digitar vírgula, a palavra-chave é destacada como TAG."
      class="tag-input"
      placeholder="Separe com vírgula: habeas corpus, indenização moral, ação civil"
      (keydown)="onTagInput($event)"
      (paste)="onPaste($event)"
      formControlName="tagsInput" />
  </div>
              </div>

              <p-dialog [(visible)]="mostrarModal" [modal]="true" [closable]="false" [showHeader]="false"
                [style]="{ width: '400px' }">
                <div class="modal-content">
                  <p>Deseja continuar no modo anônimo?</p>
                  <div class="modal-buttons">
                    <button title="Sim" pButton label="Sim" (click)="responder(true)"></button>
                    <button title="Não" pButton label="Não" class="p-button-secondary"
                      (click)="responder(false)"></button>
                  </div>
                </div>
              </p-dialog>
            </p-card>
            <br />

            <p-card class="card custom-card">
              <ng-template pTemplate="header">
                <div class="card-header">
                  <h3 class="card-title">Caracterização e Finalidade <span class="text-red-500">*</span></h3>
                </div>
              </ng-template>

              <div class="grid caracterizacao-grid">
                <div class="col-12 lg:col-4">
                  <div class="h-full">
                    <div class="p-2 h-full flex flex-column border-1 surface-border border-round caracterizacao-card"
                      style="border-radius: 6px">
                      <div class="text-900 font-bold text-base">Tipo de Processo</div>

                      <hr class="caracterizacao-hr mx-0 border-top-1 border-none surface-border" />

                      <div class="flex flex-column caracterizacao-opcoes">
                        <div *ngFor="let categoria of filtrarCategoriasProcess" class="field-checkbox">
                          <label>
                            <input type="checkbox" class="custom-caract-checkbox"
                              [checked]="selecionadoCaractFinalidade(categoria)"
                              (change)="alterarSelecaoCaractFinalidade(categoria)" />
                            {{ categoria.categoria_descricao }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 lg:col-4">
                  <div class="h-full">
                    <div class="p-2 h-full flex flex-column border-1 surface-border border-round caracterizacao-card"
                      style="border-radius: 6px">
                      <div class="text-900 text-base font-bold">Instância</div>
                      <hr class="caracterizacao-hr mx-0 border-top-1 border-none surface-border" />

                      <div class="flex flex-column caracterizacao-opcoes">
                        <div *ngFor="let categoria of filtrarCategoriasIns" class="field-checkbox">
                          <label>
                            <input type="checkbox" class="custom-caract-checkbox"
                              [checked]="selecionadoCaractFinalidade(categoria)"
                              (change)="alterarSelecaoCaractFinalidade(categoria)" />
                            {{ categoria.categoria_descricao }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 lg:col-4">
                  <div class="h-full">
                    <div class="p-2 h-full flex flex-column border-1 surface-border border-round caracterizacao-card"
                      style="border-radius: 6px">
                      <div class="text-900 font-bold">Justiça</div>
                      <hr class="caracterizacao-hr mx-0 border-top-1 border-none surface-border" />

                      <div class="flex flex-column caracterizacao-opcoes">
                        <div *ngFor="let categoria of filtrarCategoriasJus" class="field-checkbox">
                          <label>
                            <input type="checkbox" class="custom-caract-checkbox"
                              [checked]="selecionadoCaractFinalidade(categoria)"
                              (change)="alterarSelecaoCaractFinalidade(categoria)" />
                            {{ categoria.categoria_descricao }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 lg:col-12">
                  <div class="h-full">
                    <div class="p-2 h-full flex flex-column border-1 surface-border border-round caracterizacao-card"
                      style="border-radius: 6px">
                      <div class="text-900 font-bold">Área de Direito</div>
                      <hr class="caracterizacao-hr mx-0 border-top-1 border-none surface-border" />

                      <div class="area-direito-grid">
                            <div *ngFor="let categoria of filtrarCategoriasAreaDir" class="field-checkbox">
                              <label>
                                <input type="checkbox" class="custom-caract-checkbox"
                                  [checked]="selecionadoCaractFinalidade(categoria)"
                                  (change)="alterarSelecaoCaractFinalidade(categoria)" />
                                {{ categoria.categoria_descricao }}
                              </label>
                            </div>
                      </div>

                    </div>
                  </div>
                </div>

                <div class="col-12 lg:col-12">
                  <div class="h-full">
                    <div class="p-2 h-full flex flex-column border-1 surface-border border-round caracterizacao-card"
                      style="border-radius: 6px">
                      <div class="text-900 font-bold">Finalidade
                        <span class="text-red-500">*</span>
                      </div>
                      <hr class="caracterizacao-hr mx-0 border-top-1 border-none surface-border" />

                      <div class="dropdown">
                        <div class="dropdown-header" (click)="alterarDropdown()">
                          <span *ngIf="selecionarCategorias.length > 0; else placeholder">
                            {{ descricaoCategoriasSelecionadas }}
                          </span>
                          <ng-template #placeholder> Selecione as Finalidades </ng-template>
                          <span class="arrow">{{ dropdownCategoria ? "▲" : "▼" }}</span>
                        </div>

                        <div class="dropdown-content" *ngIf="dropdownCategoria">
                          <div class="search-container">
                            <input type="text" formControlName="pesquisaCategoria" (input)="filtrarCategoria()"
                              placeholder="Pesquisar..." class="search-input" />
                            <span class="search-icon">🔍</span>
                            <!-- Ícone de lupa -->
                          </div>
                          <ul>
                            <li *ngFor="let categoria of filtrarCategorias">
                              <label>
                                <input type="checkbox" [checked]="selecionado(categoria)"
                                  (change)="alterarSelecao(categoria)" />
                                {{ categoria.categoria_descricao }}
                              </label>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <br />

              <div class="mx-2 mt-3">
                <label>
                  <input type="checkbox" formControlName="anonimo"
                    (change)="toggleCheckbox(cadastro.get('anonimo')?.value)" />
                  Deseja salvar como usuário anônimo?
                </label>
              </div>

              <div class="mx-2 mt-3">
                <label>
                  <input type="checkbox" formControlName="termo"
                    (change)="toggleCheckboxTermo(cadastro.get('termo')?.value)" />
                  {{ termoMsg }}
                </label>
              </div>

              <div class="mx-2 mt-3 flex gap-2">
                <button title="Salvar" pButton pRipple label="Salvar" (click)="salvarPrompt()" class="bt-tema"></button>
                <p-button pRipple severity="secondary" label="Voltar" [routerLink]="'/painel'"></p-button>
              </div>
            </p-card>
          </form>
        </div>
      </div>
    </div>
  </div>
</main>
